import { worldPx } from '../../helpers/handleScale';
import {
  SNAPLINE_STROKE_WIDTH_PX,
  SNAP_MARKER_SIZE_PX,
  SNAP_MARKER_STROKE_WIDTH_PX,
} from '../../helpers/snapTokens';
import { Coordinate, LineSegment } from '../../types';

type SnapLinesProps = {
  snapLines: LineSegment[];
  snapPoints: Coordinate[];
  scale: number;
};

/**
 * The × marking each end of a snapline and each matched snap point. Drawn as two
 * strokes rather than a text glyph so its size and weight are set here rather than
 * inherited from font metrics, which differ between browsers.
 */
const Marker = (props: { coordinate: Coordinate; scale: number }) => {
  const { coordinate, scale } = props;
  const half = worldPx(SNAP_MARKER_SIZE_PX, scale) / 2;
  const left = coordinate.x - half;
  const right = coordinate.x + half;
  const top = coordinate.y - half;
  const bottom = coordinate.y + half;

  return (
    <path
      d={`M${left} ${top}L${right} ${bottom}M${right} ${top}L${left} ${bottom}`}
      className="snap-marker"
      strokeWidth={worldPx(SNAP_MARKER_STROKE_WIDTH_PX, scale)}
    />
  );
};

export const SnapLines = (props: SnapLinesProps) => {
  const { snapLines, snapPoints, scale } = props;

  return (
    <g className="snap-lines" pointerEvents="none">
      {snapLines.map((snapLine, index) => (
        <g key={`line-${index}`}>
          <line
            x1={snapLine.start.x}
            y1={snapLine.start.y}
            x2={snapLine.end.x}
            y2={snapLine.end.y}
            strokeWidth={worldPx(SNAPLINE_STROKE_WIDTH_PX, scale)}
          />
          <Marker coordinate={snapLine.start} scale={scale} />
          <Marker coordinate={snapLine.end} scale={scale} />
        </g>
      ))}
      {snapPoints.map((snapPoint, index) => (
        <Marker key={`point-${index}`} coordinate={snapPoint} scale={scale} />
      ))}
    </g>
  );
};
